module.exports = __webpack_public_path__ + "img/cl.75f4a4b.png";